import { el, inject, create } from "@dhx/ts-common/dom";
import { Slider, SliderEvents, Direction } from "@dhx/ts-slider";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";
import { Label } from "./helper/label";
import { isEmptyObj } from "../helper";
import { ISlider, BaseElementEvent, IBaseSliderEventHandlersMap } from "../types";


export class SliderForm extends Label {
	public config: ISlider;
	public slider: Slider;
	public events: IEventSystem<BaseElementEvent, IBaseSliderEventHandlersMap> = new EventSystem();

	constructor(container, config: ISlider) {
		super(null, config);
		this.setConfig(config);

		const render = () => this._drawSlider();
		this.mount(container, create({ render }));
	}
	clear() : void {
		this.config.value = this.config.min;
		this.slider.setValue(this.config.value);
	}
	getValue(): number[] {
		return this.slider.getValue();
	}
	disable(disabled: boolean): void {
		disabled ? this.slider.disable() : this.slider.enable();
	}
	setValue(value: string | number | number[]): void {
		this.slider.setValue(value);
	}
	setConfig(config: ISlider): void {
		if (isEmptyObj(config)) {
			return;
		}
		if (this.slider) {
			this.slider.destructor();
		}
		const sliderConfig = {
			type: this.config.type,
			id: this.config.id,
			name: this.config.name,
			mode: Direction.horizontal,
			min: 0,
			max: 100,
			step: 1,
			thumbLabel: true,
		};
		for (const key in config) {
			if (key !== "id" && key !== "type" && key !== "name") {
				sliderConfig[key] = config[key];
			}
		}
		this.config = {	type: this.config.type,	...sliderConfig };
		this.slider = new Slider(null, sliderConfig);
		this.events.fire(BaseElementEvent.configUpdate, [this.config]);
		this.config.value = this.slider.getValue();
		this.slider.events.on(SliderEvents.change, () => {
			this.config.value = this.slider.getValue();
			this.events.fire(BaseElementEvent.change, [this.config.value]);
			this.validate();
		});
		this.disable(this.config.disabled);
	}
	validate(): boolean {
		return true;
	}
	getWidget(): Slider {
		return this.slider;
	}
	protected _getRootView() {
		this.slider.paint();
		return this.slider.getRootView();
	}
	protected _drawSlider() {
		return el("div.dhx_form-group", {
		}, [
			inject(this._getRootView())
		]);
	}
}